import i18n from "i18next";
import ChainedBackend from "i18next-chained-backend";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import { classifier } from "./localization/classifier";
import { classifierList } from "./localization/classifierList";
import { common } from "./localization/common";
import { copyright } from "./localization/copyright";
import { footer } from "./localization/footer";
import { formats } from "./localization/formats";
import { globalSearch } from "./localization/globalSearch";
import { navBar } from "./localization/navBar";
import { pages } from "./localization/pages";
import { routes } from "./localization/routes";
import { defaultLocale } from "./constants/languages";
import { pageNotFound } from "./localization/pageNotFound";

i18n.use(ChainedBackend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        compatibilityJSON: "v3",
        fallbackLng: defaultLocale,
        lng: defaultLocale,
        detection: {
            order: ["path"],
            lookupFromPathIndex: 0,
        },
        debug: false,
        interpolation: {
            escapeValue: false,
        },
        resources: {
            [defaultLocale]: {
                classifier,
                classifierList,
                common,
                copyright,
                footer,
                formats,
                globalSearch,
                navBar,
                pages,
                routes,
                pageNotFound
            }
        }
    });

export default i18n;
